// src/pages/IndividualShopPage.jsx

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaHeart,
  FaShare,
  FaCheckCircle,
  FaUserFriends,
  FaArrowLeft,
  FaFilter,
} from "react-icons/fa";
import Navbar from "../../../../components/user/general/mynavbar/MyNavbar.js";
import Footer from "../../../../components/user/general/footer/Footer.js";
import ProductCard from "../../../../components/user/shoppage/productcard/ProductCard.js";
// import { shopsData } from '../../../../subscreens/users/shop/shopdata/ShopData.js';
import "../../../../assets/css/user/shoppage/individualshoppage/IndividualShopPage.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext.js";

const IndividualShopPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [shop, setShop] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState("All Products");
  const [priceFilter, setPriceFilter] = useState("all");
  const [availabilityFilter, setAvailabilityFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [isFollowing, setIsFollowing] = useState(false);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [equipments, setEquipments] = useState([]);

  const itemsPerPage = 8;

  const fetchShopDetails = () => {
    const formData = new FormData();
    formData.append("id", id);

    axios
      .post(`${baseUrl}/customer/shop/fetchShopDetails`, formData)
      .then((response) => {
        console.log(response.data);
        console.log(response.data.shop.srrentaladmin.srequipmentmanagments);
        if (response.data.success) {
          setShop(response.data.shop);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchShopDetails();
  }, []);

  useEffect(() => {
    if (shop === null) return;
  }, [shop]);

  if (!shop) {
    return (
      <>
        <Navbar />
        <div className="text-center mt-5">
          <h3>Loading Shop Details...</h3>
        </div>
        <Footer />
      </>
    );
  }

  const products = shop?.srrentaladmin?.srequipmentmanagments || [];

  console.log("PRODUCTS =", products);

  const categories = [
    "All Products",
    ...new Set(products.map((item) => item.category?.name).filter(Boolean)),
  ];

  // Filter products
  const filteredProducts = products.filter((product) => {
    const categoryMatch =
      selectedCategory === "All Products" ||
      product.category?.name?.trim() === selectedCategory.trim();
    const availabilityMatch =
      availabilityFilter === "all" ||
      (availabilityFilter === "available" && product.status === "available") ||
      (availabilityFilter === "rented" && product.status === "rented");

    let priceMatch = true;

    if (priceFilter === "low") {
      priceMatch = product.rentalrate < 1000;
    } else if (priceFilter === "medium") {
      priceMatch = product.rentalrate >= 1000 && product.rentalrate < 3000;
    } else if (priceFilter === "high") {
      priceMatch = product.rentalrate >= 3000;
    }

    return categoryMatch && availabilityMatch && priceMatch;
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++)
      stars.push(<FaStar key={`full-${i}`} className="star-icon filled" />);
    if (hasHalfStar)
      stars.push(<FaStarHalfAlt key="half" className="star-icon filled" />);
    for (let i = 0; i < 5 - Math.ceil(rating); i++)
      stars.push(<FaRegStar key={`empty-${i}`} className="star-icon" />);

    return stars;
  };

  const resetFilters = () => {
    setSelectedCategory("All Products");
    setPriceFilter("all");
    setAvailabilityFilter("all");
    setCurrentPage(1);
  };

  return (
    <>
      <Navbar />

      <div className="individual-shop-page">
        <Container>
          <Button
            variant="link"
            className="back-to-shops-btn"
            onClick={() => navigate("/shop")}
          >
            <FaArrowLeft /> Back to All Shops
          </Button>
        </Container>

        {/* Shop Banner */}
        <div
          className="shop-banner"
          style={{
            backgroundImage: `url(${baseUrlForFile}/${shop.logo})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="banner-overlay"></div>
        </div>

        <Container className="custom-container">
          {/* Shop Header */}
          <Row className="mt-4">
            {/* LEFT CARD */}
            <Col lg={6}>
              <div className="shop-header-section h-100">
                <Row className="align-items-center">
                  <Col md={3}>
                    <div className="shop-logo-wrapper">
                      {shop.logo ? (
                        <img
                          src={`${baseUrlForFile}/${shop.logo}`}
                          alt={shop.businessname}
                          className="shop-logo"
                        />
                      ) : (
                        <div className="shop-logo-initials">
                          {shop.businessname
                            .split(" ")
                            .slice(0, 2)
                            .map((w) => w[0])
                            .join("")
                            .toUpperCase()}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col md={9}>
                    <h3 className="shop-name-heading">{shop.businessname}</h3>

                    <div className="shop-meta">
                      <div className="rating-info">
                        <div className="stars-large">
                          {renderStars(Number(shop.rating || 0))}
                        </div>
                        <span className="rating-count-text">
                          ({shop.rating || 0})
                        </span>
                      </div>
                    </div>
                    <div className="shop-location-text">
                      <FaMapMarkerAlt /> {shop.address}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* RIGHT CARD */}
            <Col lg={6}>
              <Card className="about-shop-card h-100">
                <Card.Body>
                  <h4 className="about-shop-heading">About This Shop</h4>

                  <p>{shop.aboutthisshop}</p>

                  <div className="contact-item shop-email-highlight">
                    <FaEnvelope /> {shop.businessemail}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* MOBILE FILTER BUTTON */}
          <div className="mobile-filter-btn d-lg-none mb-3 text-end">
            <Button
              variant="primary"
              onClick={() => setMobileFiltersOpen(true)}
            >
              <FaFilter /> Filters
            </Button>
          </div>

          <Row className="mt-5">
            {/* Sidebar Filters */}
            <Col lg={3} md={4}>
              <div
                className={`page-filters-sidebar ${mobileFiltersOpen ? "mobile-open" : ""}`}
              >
                <div className="page-filters-container">
                  {/* Mobile Close */}
                  <div className="mobile-close-btn d-lg-none mb-2 text-end">
                    <Button
                      variant="link"
                      onClick={() => setMobileFiltersOpen(false)}
                    >
                      ✕
                    </Button>
                  </div>

                  <div className="page-filters-header">
                    <h4>
                      <FaFilter /> Filters
                    </h4>
                  </div>

                  {/* Categories */}
                  <div className="page-filter-section">
                    <h6>Categories</h6>
                    <div className="categories-list">
                      {categories.map((cat) => (
                        <div
                          key={cat}
                          className={`category-item ${selectedCategory === cat ? "active" : ""}`}
                          onClick={() => {
                            setSelectedCategory(cat);
                            setCurrentPage(1);
                            if (window.innerWidth < 992)
                              setMobileFiltersOpen(false);
                          }}
                        >
                          <span className="category-name">{cat}</span>
                          <span className="category-count">
                            (
                            {cat === "All Products"
                              ? products.length
                              : products.filter(
                                  (p) => p.category && p.category.name === cat,
                                ).length}
                            )
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Price Filter */}
                  <div className="page-filter-section">
                    <h6>Price Range</h6>
                    <Form.Select
                      value={priceFilter}
                      onChange={(e) => {
                        setPriceFilter(e.target.value);
                        setCurrentPage(1);
                        if (window.innerWidth < 992)
                          setMobileFiltersOpen(false);
                      }}
                      className="filter-select"
                    >
                      <option value="all">All Prices</option>
                      <option value="low">Low (Below 1000 PKR/hr)</option>
                      <option value="medium">
                        Medium (1000 - 3000 PKR/hr)
                      </option>
                      <option value="high">High (Above 3000 PKR/hr)</option>
                    </Form.Select>
                  </div>

                  {/* Availability Filter */}
                  <div className="page-filter-section">
                    <h6>Availability</h6>
                    <Form.Select
                      value={availabilityFilter}
                      onChange={(e) => {
                        setAvailabilityFilter(e.target.value);
                        setCurrentPage(1);
                        if (window.innerWidth < 992)
                          setMobileFiltersOpen(false);
                      }}
                      className="filter-select"
                    >
                      <option value="all">All Status</option>
                      <option value="available">Available Only</option>
                      <option value="rented">Rented</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
            </Col>

            {/* Products Grid */}
            <Col lg={9} md={8}>
              <div className="products-section">
                <div className="products-header">
                  <h3>{selectedCategory}</h3>
                  <p className="results-count">
                    Showing {indexOfFirstItem + 1}-
                    {Math.min(indexOfLastItem, filteredProducts.length)} of{" "}
                    {filteredProducts.length} products
                  </p>
                </div>

                <Row className="products-grid">
                  {currentProducts.map((product) => (
                    <Col
                      key={product.id}
                      xl={3}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-4"
                    >
                      <ProductCard
                        product={{
                          ...product,
                          name: product.equipmentname,
                          price: Number(product.rentalrate),
                          availability: product.status,
                          rating: Number(product.avg_rating || 0),
                          reviews: product.review_count || 0,
                          image: `${baseUrlForFile}/${product.image}`,
                          isFavorite: false,
                        }}
                        shopId={shop.id}
                      />
                    </Col>
                  ))}
                </Row>
                {filteredProducts.length === 0 && (
                  <div className="no-products">
                    <p>No products found in this category.</p>
                    <Button onClick={resetFilters} className="reset-btn-large">
                      Reset Filters
                    </Button>
                  </div>
                )}

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="pagination-wrapper">
                    <nav>
                      <ul className="pagination">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(totalPages)].map((_, index) => (
                          <li
                            key={index + 1}
                            className={`page-item ${index + 1 === currentPage ? "active" : ""}`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(index + 1)}
                            >
                              {index + 1}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage((prev) =>
                                Math.min(prev + 1, totalPages),
                              )
                            }
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default IndividualShopPage;
